import { render, staticRenderFns } from "./AdminFormulasEditScreen.vue?vue&type=template&id=b1e06cbc&scoped=true&"
import script from "./AdminFormulasEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminFormulasEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e06cbc",
  null
  
)

export default component.exports